import React, { useState } from "react";
import useAppStore from "../../store/AppStore";
import {
  Button,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Alert, Divider, Modal } from "antd";
import { updateUserProfile } from "./core/_request";
import { getUserById } from "../settings/users/core/_request";

const RoleSchema = Yup.object().shape({
  email: Yup.string()
    .email("Adresse mail invalid")
    .required("Adresse mail obligatoire"),
  plainPassword: Yup.string(),
  firstname: Yup.string().required("Prénom obligatoire"),
  lastname: Yup.string().required("Nom obligatoire"),
});

type UserFormData = {
  email: string;
  plainPassword: string;
  firstname: string;
  lastname: string;
};

const UserProfilePage = () => {
  const { userInfos, setUserInfos } = useAppStore();
  const [editing, setEditing] = useState<boolean>(false);
  const [deleting, setDeleting] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [unmodified, setUnmodified] = useState<boolean>(false);
  const formik = useFormik<UserFormData>({
    initialValues: {
      email: userInfos?.email ?? "",
      firstname: userInfos?.firstname ?? "",
      lastname: userInfos?.lastname ?? "",
      plainPassword: "",
    },
    validationSchema: RoleSchema,
    onSubmit: async (values) => {
      if (
        values.plainPassword?.length > 0 &&
        values.plainPassword?.length < 4
      ) {
        // roleForm.setErrors({'plainPassword': 'Mot de passe invalide'})
        setPasswordError("Mot de passe invalide");
        return;
      }
      setPasswordError(null);
      if (
        values.email === userInfos?.email &&
        values.firstname === userInfos.firstname &&
        values.lastname === userInfos.lastname &&
        values.plainPassword === ""
      ) {
        setUnmodified(true);
        setTimeout(() => {
          setUnmodified(false);
        }, 1500);
        return;
      }
      if (formik.isValid) {
        setDeleting(true);
      }
    },
  });
  return (
    <div className="row">
      <div className="col-6">
        <h4>Vos informations</h4>
        <Divider />
        <Form onSubmit={formik.handleSubmit}>
          <FormGroup className="pt-2">
            <FormLabel>Adresse mail</FormLabel>
            <FormControl
              type="email"
              value={formik.values.email}
              disabled={true}
              name="email"
              onChange={formik.handleChange}
            />
            {/* {formik.touched?.email && <span className="text-danger fs-10">
              {formik.errors?.email ?? ""}
            </span>} */}
          </FormGroup>
          <FormGroup className="pt-2">
            <FormLabel>Nom</FormLabel>
            <FormControl
              value={formik.values.lastname}
              name="lastname"
              onChange={formik.handleChange}
            />
            {formik.touched?.lastname && (
              <span className="text-danger fs-10">
                {formik.errors?.lastname ?? ""}
              </span>
            )}
          </FormGroup>
          <FormGroup className="pt-2">
            <FormLabel>Prénom</FormLabel>
            <FormControl
              value={formik.values.firstname}
              name="firstname"
              onChange={formik.handleChange}
            />
            {formik.touched?.firstname && (
              <span className="text-danger fs-10">
                {formik.errors?.firstname ?? ""}
              </span>
            )}
          </FormGroup>
          <FormGroup className="pt-2">
            <FormLabel>Mot de passe</FormLabel>
            <FormControl
              type="password"
              value={formik.values.plainPassword}
              name="plainPassword"
              onChange={formik.handleChange}
            />
            <span className="text-danger fs-10">{passwordError ?? ""}</span>
          </FormGroup>
          {unmodified && (
            <div className="p-4 pb-0">
              <Alert
                message="Aucun changement n'a été fait"
                type="error"
                showIcon={false}
              />
            </div>
          )}
          <Divider />

          <div className="d-flex">
            <Button type="submit" variant="primary">
              Enregistrer
            </Button>
            {/* <Button
              variant="danger"
              className="ms-4"
              type="button"
              onClick={() => {
                setEditing(false);
                formik.resetForm();
              }}
            >
              Annuler
            </Button> */}
          </div>
          {/* {!editing && <Button variant='warning' type='button' onClick={() => {
            setEditing(true)
          }}>Modifier</Button>} */}
        </Form>
      </div>
      <Modal
        title={"Suppression"}
        open={deleting}
        onOk={async () => {
          setDeleting(false);
          const data: any = {...formik.values}
          Object.keys(data).forEach((d) => {
            if (data[d] === "" || data[d].trim() === '') {
              delete data[d];
            }
          })
          const res = await updateUserProfile(data);
          if (res) {
            const userInfo = await getUserById(userInfos?.id?.toString() ?? "");
            if (userInfo) {
              setUserInfos(userInfo);
              formik.setValues({
                email: userInfo?.email ?? "",
                firstname: userInfo?.firstname ?? "",
                lastname: userInfo?.lastname ?? "",
                plainPassword: "",
              });
              formik.setFieldValue("plainPassword", "");
              setEditing(false);
            }
          }
        }}
        onCancel={() => setDeleting(false)}
        okText={"Ok"}
        cancelText={"Annuler"}
      >
        <div>
          <Alert
            message={
              "Voulez-vous vraiment apporter les modifications à vos informations ?"
            }
            type="warning"
            showIcon
          />
        </div>
      </Modal>
    </div>
  );
};

export default UserProfilePage;
